
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Wie sicher bin ich in diesem Raum vor Coronaviren?`}</h1>
    <h2>{`Aerosole werden mit der Delta-Variante zur grossen Gefahr. Berechnen Sie Ihr Corona-Ansteckungsrisiko mit unserem aktualisierten Tool.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;